export const translations = {
  en: {
    common: {
      dashboard: 'Dashboard',
      createPost: 'Create Post',
      smartPlanner: 'Smart Planner',
      aiAssistant: 'AI Assistant',
      messagesComments: 'Messages & Comments',
      posts: 'Posts',
      calendar: 'Calendar',
      campaigns: 'Campaigns',
      templates: 'Templates',
      competitors: 'Competitors',
      socialAccounts: 'Social Accounts',
      failures: 'Failures',
      refresh: 'Refresh',
      clear: 'Clear',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      open: 'Open',
      read: 'Read',
      all: 'All',
      loading: 'Loading…',
      markAllRead: 'Mark all read',
      english: 'English',
      arabic: 'العربية',
      language: 'Language',
      profileSettings: 'Profile settings',
      signOut: 'Sign out',
      welcomeBack: 'Welcome back',
      letsPublish: "Let's publish something great.",
      newPost: 'New Post',
      notifications: 'Notifications',
      noData: 'No data',
      headerCalendar: 'Calendar',
      headerQueue: 'Queue',
      headerDrafts: 'Drafts',
      headerLabels: 'Labels',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      headerPrimaryNav: 'Primary navigation',
      toggleTheme: 'Toggle theme',
      accountMenu: 'Account menu',
      account: 'Account',
      optional: 'optional',
      remove: 'Remove',
    },
    sidebar: {
      proTipTitle: 'Pro tip',
      proTipBody: 'Use AI hashtag suggestions to boost reach on Instagram & TikTok.',
    },
    dashboardPage: {
      title: 'Dashboard',
      subtitle: 'Overview of your scheduling pipeline.',
      scheduled: 'Scheduled',
      upcomingPosts: 'Upcoming posts',
      published: 'Published',
      in30Days: 'In the last 30 days',
      drafts: 'Drafts',
      readyToFinalize: 'Ready to finalize',
      platformsConnected: 'Platforms Connected',
      socialAccountsHint: 'Social accounts',
      recentActivity: 'Recent activity',
      last7Days: 'Last 7 days',
      upcomingScheduledPosts: 'Upcoming scheduled posts',
      next5Posts: 'Next 5 posts in your queue',
      viewAll: 'View all',
      nothingScheduled: 'Nothing scheduled yet.',
      createFirstPost: 'Create your first post',
      activityPublished: 'A post was published.',
      activityScheduled: 'A new post was scheduled.',
      activityConnected: 'A social account was connected.',
      activityDraftSaved: 'A draft was saved.',
    },
    quickPost: {
      title: 'Quick post',
      subtitle: 'Compose and schedule without leaving the dashboard.',
      fullComposer: 'Full composer',
      caption: 'Caption',
      captionPlaceholder: "What's on your mind?",
      accounts: 'Accounts',
      accountsPlaceholder: 'Pick your accounts…',
      date: 'Date',
      time: 'Time',
      saveDraft: 'Save as draft',
      schedulePost: 'Schedule post',
      checkPost: 'Check your post',
      fieldsNeedAttention: 'Some fields need your attention.',
      errWriteCaption: 'Write a caption before publishing.',
      errCaptionTooLong: 'Caption exceeds {{max}} characters.',
      errSelectAccount: 'Select at least one account.',
      errPickDate: 'Pick a date.',
      errPickTime: 'Pick a time.',
      chars: 'characters',
    },
    auth: {
      signIn: 'Sign in',
      signInSubtitle: 'Welcome back. Enter your credentials to continue.',
      welcomeBackTag: 'Ready to publish',
      loginFast: 'Fast login',
      loginSecure: 'Secure session',
      keepMeSignedIn: 'Encrypted session on this device',
      forgotPassword: 'Forgot password?',
      forgotPasswordTitle: 'Reset password',
      forgotPasswordSubtitle: 'Enter your email and we will send you a reset link.',
      sendResetLink: 'Send reset link',
      resendResetLink: 'Resend reset link',
      backToSignIn: 'Back to sign in',
      resetLinkSentTitle: 'Reset link sent',
      resetLinkSentHint: 'If this email exists, a reset link has been sent.',
      resetLinkFailedTitle: 'Could not send link',
      resetLinkFailedHint: 'Please try again in a moment.',
      showPassword: 'Show',
      hidePassword: 'Hide',
      createAccount: 'Create your account',
      createAccountSubtitle: 'Start scheduling content across all your social platforms.',
      fullName: 'Full name',
      email: 'Email',
      password: 'Password',
      createAccountBtn: 'Create account',
      alreadyHaveAccount: 'Already have an account?',
      newToPublish: 'New to Publish?',
      createAnAccount: 'Create an account',
      demoMode: 'Demo mode:',
      demoModeHint: 'any email and password will sign you in.',
      errEmailRequired: 'Email is required',
      errEmailInvalid: 'Enter a valid email',
      errPasswordRequired: 'Password is required',
      errPasswordWeak: 'Use at least 8 characters',
      errNameRequired: 'Full name is required',
    },
    postsPage: {
      title: 'Posts',
      subtitle: 'Manage scheduled content, drafts, and published posts.',
      campaign: 'Campaign',
      allCampaigns: 'All campaigns',
      noCampaign: 'No campaign',
      filtering: 'Filtering',
      showAllCampaigns: 'Show all campaigns',
      scheduled: 'Scheduled',
      published: 'Published',
      drafts: 'Drafts',
      noPostsYet: 'No {{tab}} posts yet.',
      noPostsInCampaign: 'No {{tab}} posts in "{{name}}".',
    },
    templatePicker: {
      useTemplate: 'Use template',
      emptyHint: 'Save reusable captions + hashtag groups to speed up future posts.',
      manageTemplates: 'Manage templates',
    },
    postPreview: {
      title: 'Preview',
      selectPlatform: 'Select a platform to preview your post.',
      captionFallback: 'Your caption preview will appear here…',
    },
    fileUpload: {
      dropFiles: 'Drop files here or',
      browseUpload: 'browse to upload',
      limitHint: 'Up to {{count}} images/videos — max {{size}}MB each',
      maxFilesError: 'You can upload up to {{count}} files.',
      maxSizeError: '"{{name}}" exceeds {{size}}MB limit.',
      removeFile: 'Remove {{name}}',
    },
    campaignPicker: {
      noActiveCampaigns: 'No active campaigns.',
      createOne: 'Create one',
      manageCampaigns: 'Manage campaigns',
    },
    inbox: {
      title: 'Messages & Comments Received',
      emptyTitle: 'No messages or comments',
      emptyDescription:
        'When new comments or DMs are ingested from connected social platforms, they will appear here.',
      allPlatforms: 'All platforms',
      allStatuses: 'All statuses',
      unreadOnly: 'Unread only',
      new: 'New',
      reply: 'Reply',
      replyComposer: 'Reply Composer',
      replyPlaceholderMessage: 'Reply to this message...',
      replyPlaceholderComment: 'Reply to this comment...',
      sendReply: 'Send reply',
      noReplies: 'No replies yet.',
      message: 'Message',
      comment: 'Comment',
      noSocialActivity: 'No social inbox activity yet.',
      statsLine: '{{total}} social notification{{suffix}} · {{unread}} unread',
      deleteNotification: 'Delete notification',
    },
    planner: {
      title: 'Smart Planner',
      subtitle: 'Auto-fill a month of ideas, then edit, drag, and confirm.',
      autoFillMonth: 'Auto-fill month',
      planInputs: 'Plan Inputs',
      defineStrategy: 'Define the strategy used for generation.',
      niche: 'Niche',
      postingFrequency: 'Posting frequency (per week)',
      month: 'Month',
      timezone: 'Timezone',
      platforms: 'Platforms',
      analyticsOptional: 'Past analytics (optional)',
      generatedPlanSummary: 'Generated Plan Summary',
      plannerCalendar: 'Planner Calendar',
      suggestionSlots: 'Suggestion Slots',
      createScheduledPosts: 'Create scheduled posts',
      noSuggestions: 'No suggestions yet. Click Auto-fill month.',
      nicheRequired: 'Niche required',
      nicheRequiredHint: 'Add your niche to generate a relevant plan.',
      selectPlatforms: 'Select platforms',
      selectPlatformsHint: 'Pick at least one platform.',
      planReady: 'Plan ready',
      planReadyHint: 'Review and edit slots before creating posts.',
      generationFailed: 'Generation failed',
      postsCreated: 'Posts created',
      postsCreatedHint: '{{count}} scheduled posts added.',
      couldNotCreatePosts: 'Could not create posts',
      nichePlaceholder: 'e.g. fashion, tech, real estate',
      timezonePlaceholder: 'e.g. UTC',
      analyticsPlaceholder: 'Optional context: top-performing themes, best times, weak content types.',
      slotsCount: '{{count}} slots',
      frequencyPerWeek: 'Frequency: {{frequency}}/week',
      llmStatus: 'LLM: {{status}}',
      llmOn: 'on',
      llmFallback: 'fallback',
      calendarSubtitle: 'Drag suggestion cards between days to rebalance.',
      untitledIdea: 'Untitled idea',
      suggestionSlotsSubtitle: 'Edit details before creating scheduled posts.',
      contentType: 'Content type',
      educational: 'Educational',
      promotional: 'Promotional',
      engagement: 'Engagement',
      trends: 'Trends',
      topic: 'Topic',
      captionSuggestion: 'Caption suggestion',
      noSchedule: 'No schedule',
      confidence: 'Confidence',
      confirmSmartPlan: 'Confirm smart plan',
      confirmAndCreate: 'Confirm & create',
      confirmBody: 'You are about to create {{count}} scheduled post{{suffix}} from this Smart Planner draft.',
      conflictsBody: '{{count}} slot{{suffix}} currently have time/platform conflicts.',
    },
    calendarPage: {
      title: 'Calendar',
      subtitle: 'Drag and drop scheduled posts to reschedule them.',
      monthView: 'Month',
      weekView: 'Week',
      today: 'Today',
      more: 'more',
      legend: 'Legend',
      scheduled: 'scheduled',
      published: 'published',
      draft: 'draft',
      dragToMove: 'Drag to move',
      weekdays: { sun: 'Sun', mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat' },
    },
    createPostPage: {
      aiContentLoaded: 'AI content loaded',
      aiContentLoadedHint: 'Caption and hashtags ready to review.',
      captionRequired: 'Write a caption before publishing.',
      selectAccountsRequired: 'Select at least one connected account.',
      pickDate: 'Pick a date.',
      pickTime: 'Pick a time.',
      scheduledTimeApplied: 'Scheduled time applied',
      scheduledTimeAppliedHint: 'You can still edit it below.',
      templateApplied: 'Template applied',
      templateAppliedHint: '"{{name}}" loaded into the composer.',
      compose: 'Compose',
      composeSubtitle: 'Caption, media and accounts',
      caption: 'Caption',
      captionPlaceholder: 'Share something great…',
      charactersCount: '{{count}} / 2200 characters',
      media: 'Media',
      accounts: 'Accounts',
      accountsPlaceholder: 'Select one or more accounts…',
      campaign: 'Campaign',
      schedulePostSubtitle: 'Pick a date and time',
      date: 'Date',
      time: 'Time',
      dateHint: 'YYYY-MM-DD',
      timeHint: '30-minute intervals',
      willPublishOn: 'Will publish on',
      saveAsDraft: 'Save as draft',
    },
    templatesPage: {
      title: 'Templates',
      subtitle: 'Save reusable captions, hashtag groups, and platform presets.',
      newTemplate: 'New template',
      emptyTitle: 'No templates yet',
      emptyDescription: 'Save your best captions + hashtag groups here. Apply them in one click from the Create Post composer.',
      createFirst: 'Create your first template',
      defaultPlatforms: 'Default platforms',
      deleted: 'Deleted',
      deletedHint: '"{{name}}" removed.',
      deleteFailed: 'Delete failed',
      updated: 'Template updated',
      created: 'Template created',
      saveFailed: 'Save failed',
      deleteTitle: 'Delete template?',
      deleteBody: '"{{name}}" will be permanently removed. Previously applied posts keep whatever content they had.',
      nameRequired: 'Name is required',
      editTemplate: 'Edit template',
      saveChanges: 'Save changes',
      createTemplate: 'Create template',
      name: 'Name',
      namePlaceholder: 'e.g. Product launch',
      caption: 'Caption',
      captionPlaceholder: "Reusable caption… use [PLACEHOLDERS] for parts you'll swap each time.",
      hashtags: 'Hashtags',
      hashtagsPlaceholder: '#launch #product #new',
      hashtagsHint: 'Space-separated. The # is added automatically if you forget it.',
    },
    campaignsPage: {
      title: 'Campaigns',
      subtitle: 'Group posts by theme or launch so you can track and filter them together.',
      newCampaign: 'New campaign',
      emptyTitle: 'No campaigns yet',
      emptyDescription: 'Create your first campaign to group posts around a launch, initiative, or recurring theme.',
      createFirst: 'Create your first campaign',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusArchived: 'Archived',
      postsCount: '{{count}} post{{suffix}}',
      updatedAt: 'Updated {{at}}',
      viewPosts: 'View posts →',
      deleted: 'Deleted',
      deletedHint: '"{{name}}" removed.',
      deleteFailed: 'Delete failed',
      updated: 'Campaign updated',
      created: 'Campaign created',
      saveFailed: 'Save failed',
      deleteTitle: 'Delete campaign?',
      deleteBody: '"{{name}}" will be removed. Posts stay — they just lose their campaign attribution.',
      nameRequired: 'Name is required',
      editCampaign: 'Edit campaign',
      saveChanges: 'Save changes',
      createCampaign: 'Create campaign',
      name: 'Name',
      namePlaceholder: 'e.g. Spring Launch',
      description: 'Description',
      descriptionPlaceholder: 'Optional — what posts belong in this campaign?',
      color: 'Color',
      pickColor: 'Pick color {{color}}',
      preview: 'Preview',
      campaignFallback: 'Campaign',
      status: 'Status',
      statusHint: 'Only active campaigns appear in the Create Post picker.',
    },
    aiPage: {
      title: 'AI Content Assistant',
      subtitle: 'Upload an image or video and turn it into a ready-to-publish post in seconds.',
      media: 'Media',
      mediaHint: 'JPG, PNG, WEBP, MP4, or MOV · up to 50MB',
      replace: 'Replace',
      dropMedia: 'Drop your media here',
      or: 'or',
      browseUpload: 'browse to upload',
      options: 'Options',
      tone: 'Tone',
      generate: 'Generate',
      regenerate: 'Regenerate',
      startOver: 'Start over',
      generatedContent: 'Generated content',
      readyWhenYouAre: 'Ready when you are.',
      uploadToStart: 'Upload an image to start.',
      hitGenerate: 'Hit Generate to turn this into a post.',
      dragOrBrowse: 'Drag-drop or browse — JPG, PNG, WEBP, MP4, or MOV.',
      caption: 'Caption',
      rewriting: 'Rewriting…',
      hookIdeas: 'Hook ideas',
      hookApplied: 'Hook applied',
      hashtags: 'Hashtags',
      suggestedCta: 'Suggested CTA',
      variations: 'Variations',
      swappedIn: 'Swapped in',
      swappedInHint: 'Variation loaded into caption.',
      copiedShort: 'Copied!',
      copy: 'Copy',
      useInNewPost: 'Use in new post',
      unsupportedFile: 'Unsupported file',
      unsupportedFileHint: 'Use JPG, PNG, WEBP, MP4, or MOV.',
      fileTooLarge: 'File too large',
      fileTooLargeHint: 'Max size is 50MB.',
      contentGenerated: 'Content generated',
      contentGeneratedHint: 'Review and tweak before publishing.',
      generationFailed: 'Generation failed',
      rewriteFailed: 'Rewrite failed',
      copied: 'Copied',
      copiedHint: 'Caption + hashtags on your clipboard.',
      copyFailed: 'Copy failed',
      copyFailedHint: 'Clipboard permission denied.',
    },
    competitorsPage: {
      title: 'Competitors',
      subtitle: "Track what's working for others — and learn what to do better.",
      addCompetitor: 'Add competitor',
      sync: 'Sync',
      remove: 'Remove',
      followers: 'Followers',
      postsTracked: 'Posts tracked',
      lastSyncedAt: 'Last synced {{at}}',
      notSyncedYet: 'Not synced yet',
      viewAnalytics: 'View analytics →',
      emptyTitle: 'No competitors tracked yet',
      emptyDescription:
        "Add the accounts you want to learn from. We'll pull recent posts, engagement, hashtag patterns, and recommend plays you can borrow.",
      addFirstCompetitor: 'Add your first competitor',
      syncQueued: 'Sync queued',
      syncQueuedHint: '@{{handle}} will refresh shortly.',
      syncFailed: 'Sync failed',
      removed: 'Removed',
      removedHint: '@{{handle}} removed from your list.',
      deleteFailed: 'Delete failed',
      added: 'Added',
      addedHint: '@{{handle}} added — data syncing.',
      couldNotAdd: 'Could not add',
      removeCompetitorTitle: 'Remove competitor?',
      removeCompetitorBody:
        'Removes @{{handle}} and all cached analytics. You can re-add them anytime.',
      addCompetitorTitle: 'Add competitor',
      addAndSync: 'Add + sync',
      platform: 'Platform',
      handleLabel: 'Handle or username',
      handleRequired: 'Handle or username is required',
      handleHint: 'We strip the leading @ automatically.',
      notesOptional: 'Notes (optional)',
      notesPlaceholder: 'Why are you watching this competitor?',
    },
    accountsPage: {
      title: 'Social Accounts',
      subtitlePrefix: "Connect or disconnect the accounts you've added. To add a new account, head to your",
      subtitleSuffix: '.',
      profileLink: 'profile',
      emptyTitle: 'No social accounts found',
      emptyDescription:
        "You haven't added any social accounts yet. Add them from your profile to start scheduling posts.",
      goToProfile: 'Go to Profile to add accounts',
      notAddedYet: 'Not added yet',
      notAdded: 'Not Added',
      connectedStatus: 'Connected',
      notConnectedStatus: 'Not Connected',
      connectedAt: 'Connected {{at}}',
      addFromProfileWarning: 'Add this account first from Profile',
      addInProfile: 'Add in Profile',
      disconnect: 'Disconnect',
      connect: 'Connect',
      connected: 'Connected',
      connectedHint: '{{platform}} is active again.',
      disconnected: 'Disconnected',
      disconnectedHint: '{{platform}} will no longer publish.',
      couldNotConnect: 'Could not connect',
      couldNotDisconnect: 'Could not disconnect',
    },
    failuresPage: {
      title: 'Failure & Reliability Center',
      healthy: 'Everything is healthy — no recent publishing failures.',
      failedToReview: '{{count}} failed publish{{suffix}} to review.',
      categoryAuth: 'Auth',
      categoryMedia: 'Media',
      categoryQuota: 'Rate limit',
      categoryNetwork: 'Network',
      categoryValidation: 'Validation',
      categoryUnknown: 'Unknown',
      cantAutoRetry: "Can't auto-retry",
      cantAutoRetryHint: 'This failure needs a fix first — see the suggestion on the card.',
      reconnect: 'Reconnect',
      addAccount: 'Add account',
      editPost: 'Edit post',
      allClear: 'All clear',
      noFailuresInCategory: 'No failures in the "{{category}}" category.',
      nothingFailedRecently:
        'Nothing has failed to publish recently. Scheduled posts will appear here if they need your attention.',
      showAllCategories: 'Show all categories',
      attempt: 'attempt',
      needsFixFirst: 'This failure needs a fix first',
      retry: 'Retry',
    },
  },
  ar: {
    common: {
      dashboard: 'لوحة التحكم',
      createPost: 'إنشاء منشور',
      smartPlanner: 'المخطط الذكي',
      aiAssistant: 'مساعد الذكاء الاصطناعي',
      messagesComments: 'الرسائل والتعليقات',
      posts: 'المنشورات',
      calendar: 'التقويم',
      campaigns: 'الحملات',
      templates: 'القوالب',
      competitors: 'المنافسون',
      socialAccounts: 'الحسابات الاجتماعية',
      failures: 'الأخطاء',
      refresh: 'تحديث',
      clear: 'مسح',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      open: 'فتح',
      read: 'قراءة',
      all: 'الكل',
      loading: 'جاري التحميل…',
      markAllRead: 'تحديد الكل كمقروء',
      english: 'English',
      arabic: 'العربية',
      language: 'اللغة',
      profileSettings: 'إعدادات الملف الشخصي',
      signOut: 'تسجيل الخروج',
      welcomeBack: 'مرحبًا بعودتك',
      letsPublish: 'لننشر شيئًا رائعًا.',
      newPost: 'منشور جديد',
      notifications: 'الإشعارات',
      noData: 'لا توجد بيانات',
      headerCalendar: 'التقويم',
      headerQueue: 'الطابور',
      headerDrafts: 'المسودات',
      headerLabels: 'التسميات',
      openMenu: 'فتح القائمة',
      closeMenu: 'إغلاق القائمة',
      headerPrimaryNav: 'التنقل الرئيسي',
      toggleTheme: 'تبديل المظهر',
      accountMenu: 'قائمة الحساب',
      account: 'الحساب',
      optional: 'اختياري',
      remove: 'إزالة',
    },
    sidebar: {
      proTipTitle: 'نصيحة',
      proTipBody: 'استخدم اقتراحات الهاشتاج بالذكاء الاصطناعي لزيادة الوصول على إنستغرام وتيك توك.',
    },
    dashboardPage: {
      title: 'لوحة التحكم',
      subtitle: 'نظرة عامة على سير جدولة النشر.',
      scheduled: 'مجدول',
      upcomingPosts: 'المنشورات القادمة',
      published: 'تم النشر',
      in30Days: 'خلال آخر 30 يوم',
      drafts: 'المسودات',
      readyToFinalize: 'جاهز للإكمال',
      platformsConnected: 'المنصات المتصلة',
      socialAccountsHint: 'الحسابات الاجتماعية',
      recentActivity: 'النشاط الأخير',
      last7Days: 'آخر 7 أيام',
      upcomingScheduledPosts: 'المنشورات المجدولة القادمة',
      next5Posts: 'أقرب 5 منشورات في الطابور',
      viewAll: 'عرض الكل',
      nothingScheduled: 'لا توجد منشورات مجدولة بعد.',
      createFirstPost: 'أنشئ أول منشور',
      activityPublished: 'تم نشر منشور.',
      activityScheduled: 'تمت جدولة منشور جديد.',
      activityConnected: 'تم ربط حساب اجتماعي.',
      activityDraftSaved: 'تم حفظ مسودة.',
    },
    quickPost: {
      title: 'منشور سريع',
      subtitle: 'اكتب وجدول بدون مغادرة لوحة التحكم.',
      fullComposer: 'المحرر الكامل',
      caption: 'النص',
      captionPlaceholder: 'بماذا تفكر؟',
      accounts: 'الحسابات',
      accountsPlaceholder: 'اختر حساباتك…',
      date: 'التاريخ',
      time: 'الوقت',
      saveDraft: 'حفظ كمسودة',
      schedulePost: 'جدولة المنشور',
      checkPost: 'تحقق من المنشور',
      fieldsNeedAttention: 'بعض الحقول تحتاج مراجعة.',
      errWriteCaption: 'اكتب نصًا قبل النشر.',
      errCaptionTooLong: 'النص يتجاوز {{max}} حرفًا.',
      errSelectAccount: 'اختر حسابًا واحدًا على الأقل.',
      errPickDate: 'اختر تاريخًا.',
      errPickTime: 'اختر وقتًا.',
      chars: 'حرف',
    },
    auth: {
      signIn: 'تسجيل الدخول',
      signInSubtitle: 'مرحبًا بعودتك. أدخل بياناتك للمتابعة.',
      welcomeBackTag: 'جاهز للنشر',
      loginFast: 'دخول سريع',
      loginSecure: 'جلسة آمنة',
      keepMeSignedIn: 'جلسة مشفرة على هذا الجهاز',
      forgotPassword: 'نسيت كلمة المرور؟',
      forgotPasswordTitle: 'إعادة تعيين كلمة المرور',
      forgotPasswordSubtitle: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.',
      sendResetLink: 'إرسال رابط إعادة التعيين',
      resendResetLink: 'إعادة إرسال الرابط',
      backToSignIn: 'العودة لتسجيل الدخول',
      resetLinkSentTitle: 'تم إرسال الرابط',
      resetLinkSentHint: 'إذا كان البريد موجودًا، تم إرسال رابط إعادة التعيين.',
      resetLinkFailedTitle: 'تعذر إرسال الرابط',
      resetLinkFailedHint: 'حاول مرة أخرى بعد قليل.',
      showPassword: 'إظهار',
      hidePassword: 'إخفاء',
      createAccount: 'إنشاء حساب',
      createAccountSubtitle: 'ابدأ جدولة المحتوى عبر جميع منصاتك الاجتماعية.',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      createAccountBtn: 'إنشاء حساب',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      newToPublish: 'جديد في Publish؟',
      createAnAccount: 'أنشئ حسابًا',
      demoMode: 'وضع التجربة:',
      demoModeHint: 'أي بريد إلكتروني وكلمة مرور سيدخلك للنظام.',
      errEmailRequired: 'البريد الإلكتروني مطلوب',
      errEmailInvalid: 'أدخل بريدًا إلكترونيًا صحيحًا',
      errPasswordRequired: 'كلمة المرور مطلوبة',
      errPasswordWeak: 'استخدم 8 أحرف على الأقل',
      errNameRequired: 'الاسم الكامل مطلوب',
    },
    postsPage: {
      title: 'المنشورات',
      subtitle: 'إدارة المنشورات المجدولة والمسودات والمنشورة.',
      campaign: 'الحملة',
      allCampaigns: 'كل الحملات',
      noCampaign: 'بدون حملة',
      filtering: 'التصفية',
      showAllCampaigns: 'عرض كل الحملات',
      scheduled: 'مجدول',
      published: 'منشور',
      drafts: 'مسودات',
      noPostsYet: 'لا توجد منشورات {{tab}} بعد.',
      noPostsInCampaign: 'لا توجد منشورات {{tab}} في "{{name}}".',
    },
    templatePicker: {
      useTemplate: 'استخدام قالب',
      emptyHint: 'احفظ نصوصًا قابلة لإعادة الاستخدام ومجموعات هاشتاج لتسريع المنشورات القادمة.',
      manageTemplates: 'إدارة القوالب',
    },
    postPreview: {
      title: 'المعاينة',
      selectPlatform: 'اختر منصة لمعاينة منشورك.',
      captionFallback: 'ستظهر معاينة النص هنا…',
    },
    fileUpload: {
      dropFiles: 'اسحب الملفات هنا أو',
      browseUpload: 'تصفح للرفع',
      limitHint: 'حتى {{count}} صور/فيديو — حد أقصى {{size}}MB لكل ملف',
      maxFilesError: 'يمكنك رفع حتى {{count}} ملفات.',
      maxSizeError: '"{{name}}" يتجاوز حد {{size}}MB.',
      removeFile: 'إزالة {{name}}',
    },
    campaignPicker: {
      noActiveCampaigns: 'لا توجد حملات نشطة.',
      createOne: 'إنشاء حملة',
      manageCampaigns: 'إدارة الحملات',
    },
    inbox: {
      title: 'الرسائل والتعليقات الواردة',
      emptyTitle: 'لا توجد رسائل أو تعليقات',
      emptyDescription:
        'عند وصول تعليقات أو رسائل جديدة من المنصات المرتبطة ستظهر هنا.',
      allPlatforms: 'كل المنصات',
      allStatuses: 'كل الحالات',
      unreadOnly: 'غير المقروء فقط',
      new: 'جديد',
      reply: 'رد',
      replyComposer: 'محرر الرد',
      replyPlaceholderMessage: 'اكتب ردًا على هذه الرسالة...',
      replyPlaceholderComment: 'اكتب ردًا على هذا التعليق...',
      sendReply: 'إرسال الرد',
      noReplies: 'لا توجد ردود بعد.',
      message: 'رسالة',
      comment: 'تعليق',
      noSocialActivity: 'لا يوجد نشاط اجتماعي بعد.',
      statsLine: '{{total}} إشعار اجتماعي · {{unread}} غير مقروء',
      deleteNotification: 'حذف الإشعار',
    },
    planner: {
      title: 'المخطط الذكي',
      subtitle: 'املأ أفكار الشهر تلقائيًا ثم عدّل واسحب وأكد.',
      autoFillMonth: 'ملء الشهر تلقائيًا',
      planInputs: 'مدخلات الخطة',
      defineStrategy: 'حدد الاستراتيجية المستخدمة في التوليد.',
      niche: 'المجال',
      postingFrequency: 'معدل النشر (أسبوعيًا)',
      month: 'الشهر',
      timezone: 'المنطقة الزمنية',
      platforms: 'المنصات',
      analyticsOptional: 'تحليلات سابقة (اختياري)',
      generatedPlanSummary: 'ملخص الخطة المولدة',
      plannerCalendar: 'تقويم الخطة',
      suggestionSlots: 'خانات الاقتراحات',
      createScheduledPosts: 'إنشاء منشورات مجدولة',
      noSuggestions: 'لا توجد اقتراحات بعد. اضغط ملء الشهر تلقائيًا.',
      nicheRequired: 'المجال مطلوب',
      nicheRequiredHint: 'أضف مجالك لتوليد خطة مناسبة.',
      selectPlatforms: 'اختر المنصات',
      selectPlatformsHint: 'اختر منصة واحدة على الأقل.',
      planReady: 'الخطة جاهزة',
      planReadyHint: 'راجع وعدّل الخانات قبل إنشاء المنشورات.',
      generationFailed: 'فشل التوليد',
      postsCreated: 'تم إنشاء المنشورات',
      postsCreatedHint: 'تمت إضافة {{count}} منشور مجدول.',
      couldNotCreatePosts: 'تعذر إنشاء المنشورات',
      nichePlaceholder: 'مثال: أزياء، تقنية، عقارات',
      timezonePlaceholder: 'مثال: UTC',
      analyticsPlaceholder: 'سياق اختياري: أفضل المواضيع أداءً، أفضل الأوقات، وأنواع المحتوى الضعيفة.',
      slotsCount: '{{count}} خانة',
      frequencyPerWeek: 'التكرار: {{frequency}}/الأسبوع',
      llmStatus: 'نموذج اللغة: {{status}}',
      llmOn: 'مفعّل',
      llmFallback: 'احتياطي',
      calendarSubtitle: 'اسحب بطاقات الاقتراح بين الأيام لإعادة التوازن.',
      untitledIdea: 'فكرة بدون عنوان',
      suggestionSlotsSubtitle: 'عدّل التفاصيل قبل إنشاء المنشورات المجدولة.',
      contentType: 'نوع المحتوى',
      educational: 'تعليمي',
      promotional: 'ترويجي',
      engagement: 'تفاعل',
      trends: 'ترندات',
      topic: 'الموضوع',
      captionSuggestion: 'اقتراح النص',
      noSchedule: 'بدون جدولة',
      confidence: 'الثقة',
      confirmSmartPlan: 'تأكيد الخطة الذكية',
      confirmAndCreate: 'تأكيد وإنشاء',
      confirmBody: 'أنت على وشك إنشاء {{count}} منشور مجدول من مسودة المخطط الذكي هذه.',
      conflictsBody: 'يوجد {{count}} خانة بها تعارضات وقت/منصة حاليًا.',
    },
    calendarPage: {
      title: 'التقويم',
      subtitle: 'اسحب وأفلت المنشورات المجدولة لإعادة جدولتها.',
      monthView: 'شهر',
      weekView: 'أسبوع',
      today: 'اليوم',
      more: 'أكثر',
      legend: 'الدليل',
      scheduled: 'مجدول',
      published: 'منشور',
      draft: 'مسودة',
      dragToMove: 'اسحب للتحريك',
      weekdays: { sun: 'الأحد', mon: 'الاثنين', tue: 'الثلاثاء', wed: 'الأربعاء', thu: 'الخميس', fri: 'الجمعة', sat: 'السبت' },
    },
    createPostPage: {
      aiContentLoaded: 'تم تحميل محتوى الذكاء الاصطناعي',
      aiContentLoadedHint: 'النص والهاشتاجات جاهزة للمراجعة.',
      captionRequired: 'اكتب نصًا قبل النشر.',
      selectAccountsRequired: 'اختر حسابًا متصلًا واحدًا على الأقل.',
      pickDate: 'اختر تاريخًا.',
      pickTime: 'اختر وقتًا.',
      scheduledTimeApplied: 'تم تطبيق وقت الجدولة',
      scheduledTimeAppliedHint: 'لا يزال بإمكانك تعديله أدناه.',
      templateApplied: 'تم تطبيق القالب',
      templateAppliedHint: 'تم تحميل "{{name}}" داخل محرر الإنشاء.',
      compose: 'التحرير',
      composeSubtitle: 'النص والوسائط والحسابات',
      caption: 'النص',
      captionPlaceholder: 'شارك شيئًا رائعًا…',
      charactersCount: '{{count}} / 2200 حرف',
      media: 'الوسائط',
      accounts: 'الحسابات',
      accountsPlaceholder: 'اختر حسابًا أو أكثر…',
      campaign: 'الحملة',
      schedulePost: 'جدولة المنشور',
      schedulePostSubtitle: 'اختر التاريخ والوقت',
      date: 'التاريخ',
      time: 'الوقت',
      dateHint: 'YYYY-MM-DD',
      timeHint: 'فواصل 30 دقيقة',
      willPublishOn: 'سيتم النشر في',
      saveAsDraft: 'حفظ كمسودة',
    },
    templatesPage: {
      title: 'القوالب',
      subtitle: 'احفظ نصوصًا قابلة لإعادة الاستخدام ومجموعات هاشتاج وإعدادات منصات جاهزة.',
      newTemplate: 'قالب جديد',
      emptyTitle: 'لا توجد قوالب بعد',
      emptyDescription: 'احفظ أفضل نصوصك ومجموعات الهاشتاج هنا. طبّقها بضغطة واحدة من محرر إنشاء المنشور.',
      createFirst: 'أنشئ أول قالب',
      defaultPlatforms: 'المنصات الافتراضية',
      deleted: 'تم الحذف',
      deletedHint: 'تم حذف "{{name}}".',
      deleteFailed: 'فشل الحذف',
      updated: 'تم تحديث القالب',
      created: 'تم إنشاء القالب',
      saveFailed: 'فشل الحفظ',
      deleteTitle: 'حذف القالب؟',
      deleteBody: 'سيتم حذف "{{name}}" نهائيًا. المنشورات التي استُخدم بها سابقًا ستحتفظ بالمحتوى الحالي.',
      nameRequired: 'الاسم مطلوب',
      editTemplate: 'تعديل القالب',
      saveChanges: 'حفظ التغييرات',
      createTemplate: 'إنشاء قالب',
      name: 'الاسم',
      namePlaceholder: 'مثال: إطلاق منتج',
      caption: 'النص',
      captionPlaceholder: 'نص قابل لإعادة الاستخدام… استخدم [PLACEHOLDERS] للأجزاء التي ستغيّرها كل مرة.',
      hashtags: 'الهاشتاجات',
      hashtagsPlaceholder: '#launch #product #new',
      hashtagsHint: 'مفصولة بمسافة. تتم إضافة # تلقائيًا إذا نسيتها.',
    },
    campaignsPage: {
      title: 'الحملات',
      subtitle: 'جمّع المنشورات حسب موضوع أو إطلاق لتتمكن من تتبعها وتصفيةها معًا.',
      newCampaign: 'حملة جديدة',
      emptyTitle: 'لا توجد حملات بعد',
      emptyDescription: 'أنشئ أول حملة لتجميع المنشورات حول إطلاق أو مبادرة أو موضوع متكرر.',
      createFirst: 'أنشئ أول حملة',
      statusActive: 'نشطة',
      statusCompleted: 'مكتملة',
      statusArchived: 'مؤرشفة',
      postsCount: '{{count}} منشور{{suffix}}',
      updatedAt: 'آخر تحديث {{at}}',
      viewPosts: 'عرض المنشورات ←',
      deleted: 'تم الحذف',
      deletedHint: 'تم حذف "{{name}}".',
      deleteFailed: 'فشل الحذف',
      updated: 'تم تحديث الحملة',
      created: 'تم إنشاء الحملة',
      saveFailed: 'فشل الحفظ',
      deleteTitle: 'حذف الحملة؟',
      deleteBody: 'سيتم حذف "{{name}}". المنشورات ستبقى لكنها ستفقد ربطها بهذه الحملة.',
      nameRequired: 'الاسم مطلوب',
      editCampaign: 'تعديل الحملة',
      saveChanges: 'حفظ التغييرات',
      createCampaign: 'إنشاء حملة',
      name: 'الاسم',
      namePlaceholder: 'مثال: إطلاق الربيع',
      description: 'الوصف',
      descriptionPlaceholder: 'اختياري — ما المنشورات التي تنتمي لهذه الحملة؟',
      color: 'اللون',
      pickColor: 'اختر اللون {{color}}',
      preview: 'معاينة',
      campaignFallback: 'حملة',
      status: 'الحالة',
      statusHint: 'تظهر فقط الحملات النشطة في منتقي إنشاء المنشور.',
    },
    aiPage: {
      title: 'مساعد المحتوى بالذكاء الاصطناعي',
      subtitle: 'حمّل صورة أو فيديو وحوّله إلى منشور جاهز للنشر خلال ثوانٍ.',
      media: 'الوسائط',
      mediaHint: 'JPG, PNG, WEBP, MP4, or MOV · حتى 50MB',
      replace: 'استبدال',
      dropMedia: 'أسقط الوسائط هنا',
      or: 'أو',
      browseUpload: 'تصفح للرفع',
      options: 'الخيارات',
      tone: 'النبرة',
      generate: 'توليد',
      regenerate: 'إعادة توليد',
      startOver: 'البدء من جديد',
      generatedContent: 'المحتوى المُولّد',
      readyWhenYouAre: 'جاهز عندما تكون جاهزًا.',
      uploadToStart: 'حمّل صورة للبدء.',
      hitGenerate: 'اضغط توليد لتحويل هذا إلى منشور.',
      dragOrBrowse: 'اسحب وأفلت أو تصفّح — JPG, PNG, WEBP, MP4, or MOV.',
      caption: 'النص',
      rewriting: 'إعادة الصياغة…',
      hookIdeas: 'أفكار افتتاحية',
      hookApplied: 'تم تطبيق الافتتاحية',
      hashtags: 'الهاشتاجات',
      suggestedCta: 'دعوة لاتخاذ إجراء مقترحة',
      variations: 'صياغات بديلة',
      swappedIn: 'تم الاستبدال',
      swappedInHint: 'تم تحميل الصياغة داخل النص.',
      copiedShort: 'تم النسخ!',
      copy: 'نسخ',
      useInNewPost: 'استخدمه في منشور جديد',
      unsupportedFile: 'ملف غير مدعوم',
      unsupportedFileHint: 'استخدم JPG أو PNG أو WEBP أو MP4 أو MOV.',
      fileTooLarge: 'الملف كبير جدًا',
      fileTooLargeHint: 'الحد الأقصى 50MB.',
      contentGenerated: 'تم توليد المحتوى',
      contentGeneratedHint: 'راجعه وعدّله قبل النشر.',
      generationFailed: 'فشل التوليد',
      rewriteFailed: 'فشلت إعادة الصياغة',
      copied: 'تم النسخ',
      copiedHint: 'تم نسخ النص والهاشتاجات إلى الحافظة.',
      copyFailed: 'فشل النسخ',
      copyFailedHint: 'تم رفض إذن الوصول إلى الحافظة.',
    },
    competitorsPage: {
      title: 'المنافسون',
      subtitle: 'تابع ما ينجح لدى الآخرين وتعلّم كيف تطوّر محتواك.',
      addCompetitor: 'إضافة منافس',
      sync: 'مزامنة',
      remove: 'إزالة',
      followers: 'المتابعون',
      postsTracked: 'المنشورات المتابعة',
      lastSyncedAt: 'آخر مزامنة {{at}}',
      notSyncedYet: 'لم تتم المزامنة بعد',
      viewAnalytics: 'عرض التحليلات ←',
      emptyTitle: 'لا يوجد منافسون متابعون بعد',
      emptyDescription:
        'أضف الحسابات التي تريد التعلم منها. سنجلب أحدث المنشورات والتفاعل وأنماط الهاشتاج ونقترح أفكارًا يمكنك الاستفادة منها.',
      addFirstCompetitor: 'أضف أول منافس',
      syncQueued: 'تمت جدولة المزامنة',
      syncQueuedHint: '@{{handle}} سيتم تحديثه بعد قليل.',
      syncFailed: 'فشلت المزامنة',
      removed: 'تمت الإزالة',
      removedHint: 'تمت إزالة @{{handle}} من قائمتك.',
      deleteFailed: 'فشل الحذف',
      added: 'تمت الإضافة',
      addedHint: 'تمت إضافة @{{handle}} وجارٍ مزامنة البيانات.',
      couldNotAdd: 'تعذرت الإضافة',
      removeCompetitorTitle: 'إزالة المنافس؟',
      removeCompetitorBody:
        'سيتم حذف @{{handle}} وجميع التحليلات المخزنة. يمكنك إضافته مرة أخرى في أي وقت.',
      addCompetitorTitle: 'إضافة منافس',
      addAndSync: 'إضافة + مزامنة',
      platform: 'المنصة',
      handleLabel: 'المعرّف أو اسم المستخدم',
      handleRequired: 'المعرّف أو اسم المستخدم مطلوب',
      handleHint: 'نقوم بإزالة علامة @ تلقائيًا.',
      notesOptional: 'ملاحظات (اختياري)',
      notesPlaceholder: 'لماذا تتابع هذا المنافس؟',
    },
    accountsPage: {
      title: 'الحسابات الاجتماعية',
      subtitlePrefix: 'قم بتوصيل أو فصل الحسابات التي أضفتها. لإضافة حساب جديد، انتقل إلى',
      subtitleSuffix: '.',
      profileLink: 'الملف الشخصي',
      emptyTitle: 'لا توجد حسابات اجتماعية',
      emptyDescription: 'لم تقم بإضافة أي حسابات اجتماعية بعد. أضفها من الملف الشخصي لبدء جدولة المنشورات.',
      goToProfile: 'الذهاب للملف الشخصي لإضافة حسابات',
      notAddedYet: 'لم تتم إضافته بعد',
      notAdded: 'غير مضاف',
      connectedStatus: 'متصل',
      notConnectedStatus: 'غير متصل',
      connectedAt: 'متصل {{at}}',
      addFromProfileWarning: 'أضف هذا الحساب أولاً من الملف الشخصي',
      addInProfile: 'إضافة من الملف الشخصي',
      disconnect: 'فصل الاتصال',
      connect: 'اتصال',
      connected: 'تم الاتصال',
      connectedHint: '{{platform}} نشط مرة أخرى.',
      disconnected: 'تم فصل الاتصال',
      disconnectedHint: '{{platform}} لن ينشر بعد الآن.',
      couldNotConnect: 'تعذر الاتصال',
      couldNotDisconnect: 'تعذر فصل الاتصال',
    },
    failuresPage: {
      title: 'مركز الأعطال والموثوقية',
      healthy: 'كل شيء يعمل بشكل جيد — لا توجد أعطال نشر حديثة.',
      failedToReview: 'يوجد {{count}} عملية نشر فاشلة للمراجعة.',
      categoryAuth: 'المصادقة',
      categoryMedia: 'الوسائط',
      categoryQuota: 'حد المعدل',
      categoryNetwork: 'الشبكة',
      categoryValidation: 'التحقق',
      categoryUnknown: 'غير معروف',
      cantAutoRetry: 'لا يمكن إعادة المحاولة تلقائيًا',
      cantAutoRetryHint: 'هذا العطل يحتاج إصلاحًا أولًا — راجع الاقتراح داخل البطاقة.',
      reconnect: 'إعادة الربط',
      addAccount: 'إضافة حساب',
      editPost: 'تعديل المنشور',
      allClear: 'لا توجد مشاكل',
      noFailuresInCategory: 'لا توجد أعطال ضمن فئة "{{category}}".',
      nothingFailedRecently: 'لم يفشل أي نشر مؤخرًا. ستظهر المنشورات هنا عند الحاجة لتدخلك.',
      showAllCategories: 'عرض كل الفئات',
      attempt: 'محاولة',
      needsFixFirst: 'هذا العطل يحتاج إصلاحًا أولًا',
      retry: 'إعادة المحاولة',
    },
  },
};
